import { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiTableHeadStyles = () => ({
    styleOverrides: {
        root: {
            color: variables.colors.other.table.headerText,
            fontWeight: 'bold',
        },
    },
});

const createMuiTableCellStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            borderBottomWidth: '0',
            color: variables.colors.other.table.text,
        },
        head: {
            fontWeight: 'bold',
            color: variables.colors.other.table.headerText,
            borderBottomWidth: '1px',
        },
    },
});

const createMuiTableRowStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            transition: 'all ease-in-out 0.15s',
            '&:nth-of-type(even)': {
                backgroundColor: variables.colors.other.table.evenRowHighlight,
            },
            '&:hover': {
                color: variables.colors.other.table.hoverText,
                backgroundColor: variables.colors.other.table.hoverHighlight,
            },
            '&.selected': {
                boxShadow: variables.boxShadows.tableSelectedShadow,
            },
        },
        head: {
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: 'transparent',
                cursor: 'initial',
            },
        },
    },
});

export { createMuiTableHeadStyles, createMuiTableCellStyles, createMuiTableRowStyles };
